import JarvisButton from "components/JarvisButton";
import Box from "./Box";
import Text from "./Text";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { PHCOnboardingApis } from "stores/PHC/PHCOnboarding/PHCOnboardingApis";
import { PHCOnboardingParser } from "stores/PHC/PHCOnboarding/PHCOnboardingParser";
import { PHCOnboardingActions } from "stores/PHC/PHCOnboarding/PHCOnboardingAction";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { usePhcTheme } from "pages/PHC/Dashboard/PhcThemeContext";
import { getPhcGlassCardSx } from "pages/PHC/Dashboard/phcThemes";

const LockedTableWrapper = ({ locked, children }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const source = useSelector((state) => state.common.source);
  const { theme, mode } = usePhcTheme();

  const handleUnlock = async () => {
    try {
      if (source === "navia") {
        // Navia → ReKYC
        history.push({
          pathname: "/re-kyc",
          state: { from: "phcIframe" },
        });
      } else {
        // PHC → CKYC via API redirect
        const res = await PHCOnboardingApis.redirectToCkyc();

        //  if (res?.code === "200") {
        if (res?.code == 200) {
          const onboardingResponse =
            await PHCOnboardingApis.getOnboardingData();

          const parsedOnboardingData =
            PHCOnboardingParser.onboardingData(onboardingResponse);

          dispatch(
            PHCOnboardingActions.updatePHCOnboardingData(parsedOnboardingData),
          );
        }
      }
    } catch (error) {
      console.error("CKYC redirect failed", error);
    }
  };

  if (!locked) return children || null;

  return (
    <Box
      sx={{
        textAlign: "center",
        width: "100%",
        maxWidth: "100%",
        px: 1.5,
        py: 1.75,
        ...getPhcGlassCardSx(mode),
      }}
    >
      <LockOpenIcon sx={{ color: "#2B70C5", fontSize: { xs: 20, sm: 24 } }} />
      <Text
        sx={{
          fontWeight: 600,
          mb: 1.5,
          mt: 0.5,
          fontSize: { xs: "12px", sm: "16px" },
          color: theme.textPrimary,
          lineHeight: 1.35,
        }}
      >
        Complete KYC to access risk score
      </Text>

      <JarvisButton
        fullWidth
        variant="contained"
        sx={{ textTransform: "none", minHeight: { xs: 36, sm: 42 } }}
        disableEndIcon
        onClick={handleUnlock}
      >
        Unlock
      </JarvisButton>
    </Box>
  );
};

export default LockedTableWrapper;
